import React, { useEffect } from 'react';
import { Box, Container, Typography, Card, CardContent, Grid, Chip, Stack, Button } from '@mui/material';
import { Check, LaptopMac } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const FacturationFreelance = () => {
  const navigate = useNavigate();

  const goToRegisterTracked = () => {
    const params = new URLSearchParams({
      utm_source: 'site_facteio',
      utm_medium: 'cta',
      utm_campaign: 'facturation_freelance',
      utm_content: 'cta_page'
    });
    navigate(`/register?${params.toString()}`);
  };

  useEffect(() => {
    document.title = 'Logiciel devis facture freelance | Facteio';
    const description = 'Facturation freelance: modèle simple, suivi honoraires, mentions réglementaires et documents prêts à envoyer.';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
  }, []);

  return (
    <Box sx={(theme) => ({ background: theme.palette.background.default, minHeight: '100vh', py: 5 })}>
      <Container maxWidth="lg">
        <Button variant="text" onClick={() => navigate('/')} sx={{ mb: 2, fontWeight: 600 }}>← Retour à l'accueil</Button>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" mb={2}>
          <Chip icon={<LaptopMac />} label="Facturation Freelance" sx={{ bgcolor: '#E5E8EE', color: '#1F2937' }} />
          <Chip icon={<Check />} label="Discours orienté honoraires" />
          <Chip icon={<Check />} label="SEO + Ads ciblées" />
        </Stack>

        <Typography variant="h3" fontWeight={800} mb={1}>Freelance & profession libérale: facturation ciblée</Typography>
        <Typography variant="h6" color="text.secondary" mb={4}>
          Idéal pour consultants, designers, développeurs, coachs et professions libérales: simple, rapide et conforme.
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card><CardContent>
              <Typography variant="h6" fontWeight={700} mb={2}>Profession libérale</Typography>
              <Typography>• Modèle simple</Typography>
              <Typography>• Suivi honoraires</Typography>
              <Typography>• Mentions réglementaires</Typography>
            </CardContent></Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card><CardContent>
              <Typography variant="h6" fontWeight={700} mb={2}>Différenciation marché</Typography>
              <Typography>• Ciblage par activité et intention de recherche</Typography>
              <Typography>• Promesse anti-admin concrète</Typography>
              <Typography>• Message prêt pour landing + Ads</Typography>
            </CardContent></Card>
          </Grid>
        </Grid>

        <Card sx={{ mt: 4, border: '1px solid #D5CDC3' }}>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h5" fontWeight={800} mb={1}>
              Facturez proprement, sans vous disperser
            </Typography>
            <Typography color="text.secondary" mb={2}>
              Modèle simple, suivi des honoraires et mentions réglementaires déjà cadrées pour gagner du temps.
            </Typography>
            <Button
              variant="contained"
              sx={{ background: 'linear-gradient(135deg, #1F2937 0%, #4B5563 100%)' }}
              onClick={goToRegisterTracked}
            >
              Essayer Facteio pour Freelance
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default FacturationFreelance;
